/**
 * Traducciones de paquetes: la rejilla pública y el panel.
 * Este archivo es SUYO — ver la nota de `shop.ts`.
 */
export const packagesEn: Record<string, string> = {
  Membresías: "Memberships",
  "{{n}} días membresía": "{{n}}-day membership",
  "No comisionable y no puntos": "Non-commissionable, no points",
  Inscribirme: "Sign me up",
  "Inscribirme con {{nombre}}": "Sign me up with {{nombre}}",
  "Paquetes · todos": "Packages · all",
  Beneficios: "Benefits",
  // ═══════════════════════════════════════════════════════════════════
  // REJILLA PÚBLICA · /paquetes
  //
  // Lo que NO va aquí: el nombre y el gancho de cada paquete. Llegan
  // traducidos del servidor y se resuelven con
  // `contentFor(pkg.translations, locale)` — los escribe quien administra
  // el catálogo, y meterlos aquí obligaría a desplegar para publicar un
  // paquete.
  //
  // `{{n}}`, `{{importe}}`, `{{categoria}}`… son interpolaciones: tienen
  // que aparecer IGUAL en el inglés o el dato desaparece de la frase.
  // ═══════════════════════════════════════════════════════════════════

  // ── Portada ───────────────────────────────────────────────────────
  "Paquetes mensuales": "Monthly packages",
  /*
   * El titular viaja ENTERO en una sola clave, y `a precio de paquete`
   * es el trozo que `PageHero` busca dentro para resaltarlo. Por eso la
   * traducción inglesa del titular tiene que CONTENER literalmente la
   * traducción del resalte: si una dice "at package price" y la otra
   * "at package prices", el titular se pinta entero y sin resalte —que
   * es degradar bien, pero se pierde el énfasis—.
   *
   * Antes eran dos claves (`Tu compra de cada mes,` + el resalte). Una
   * frase partida en dos claves no se puede traducir: en inglés el
   * énfasis cae en otras palabras y el traductor recibe dos cachos sin
   * contexto.
   */
  "Tu compra de cada mes, a precio de paquete": "Your order every month, at package price",
  "a precio de paquete": "at package price",
  "Un paquete es tu recompra mensual con descuento: eliges los productos una vez y se te cobran mes con mes. Ahorras hasta un {{personal}}%, y con franquicia digital hasta un {{franquicia}}%.":
    "A package is your monthly restock at a discount: you pick the products once and they're charged month after month. You save up to {{personal}}%, and up to {{franquicia}}% with a digital franchise.",
  "Ver los paquetes": "See the packages",

  // El disco de la derecha (`PackagesHeroDial`). Es decoración —está
  // fuera del árbol de accesibilidad— pero se LEE, así que se traduce.
  "Ahorra hasta": "Save up to",
  "Con franquicia digital": "With a digital franchise",
  "{{personal}}% en recompra personal": "{{personal}}% on personal restock",

  // ── Pestañas ──────────────────────────────────────────────────────
  //
  // "Recompra personal" y "Negocio digital" son los valores de
  // `PACKAGE_CATEGORY_LABELS` del contrato, que en este proyecto son
  // también las claves de traducción. Si allá se renombra una categoría,
  // aquí hay que renombrar la clave.
  "Categoría de paquete": "Package category",
  "Recompra personal": "Personal restock",
  "Negocio digital": "Digital business",

  // ── Fila de datos ─────────────────────────────────────────────────
  "{{n}} paquete": "{{n}} package",
  "{{n}} paquetes": "{{n}} packages",
  "Hasta un {{n}}% de descuento": "Up to {{n}}% off",

  // ── Tarjeta ───────────────────────────────────────────────────────
  "{{n}}% menos": "{{n}}% off",
  Incluye: "Includes",
  "Producto del paquete": "Package product",
  "y {{n}} producto más": "and {{n}} more product",
  "y {{n}} productos más": "and {{n}} more products",
  "Por separado": "Bought separately",
  "al mes, se renueva solo": "per month, renews on its own",
  "Ahorras {{importe}}": "You save {{importe}}",
  "Este paquete no se vende en {{pedida}}. El precio se muestra en {{usada}}.":
    "This package isn't sold in {{pedida}}. The price is shown in {{usada}}.",
  "{{n}} volume points": "{{n}} volume points",
  "{{n}} pieza al mes": "{{n}} item a month",
  "{{n}} piezas al mes": "{{n}} items a month",
  "Con franquicia digital, un {{n}}% menos en este paquete.":
    "With a digital franchise, {{n}}% off this package.",
  "Tu precio de franquiciatario · {{n}}% menos": "Your franchisee price · {{n}}% off",
  "Ver franquicias": "See franchises",
  "Elegir este paquete": "Choose this package",
  "Elegir {{paquete}}": "Choose {{paquete}}",
  "Paquetes · {{categoria}}": "Packages · {{categoria}}",

  // ── Los tres estados de la petición ───────────────────────────────
  "Cargando los paquetes…": "Loading the packages…",
  "No pudimos cargar los paquetes": "We couldn't load the packages",
  "Todavía no hay paquetes personales publicados":
    "No personal packages published yet",
  "Estamos armando los paquetes. Mientras tanto, mira el catálogo completo.":
    "We're putting the packages together. In the meantime, browse the full catalog.",
  "Ir a la tienda": "Go to the shop",
  "Todavía no hay paquetes de negocio digital publicados":
    "No digital business packages published yet",
  "Estos paquetes son para quien ya tiene su franquicia digital. Mientras los preparamos, puedes conocer cómo funciona.":
    "These packages are for people who already hold a digital franchise. While we get them ready, you can read how it works.",

  // ── Compuerta de la pestaña de negocio digital ────────────────────
  "Para franquiciatarias y franquiciatarios": "For digital franchise owners",
  "Estos paquetes se contratan con una franquicia digital activa. Es lo que sube el techo del descuento del {{personal}}% al {{franquicia}}% y lo que hace que las comisiones que generas se acumulen para ti.":
    "These packages require an active digital franchise. That's what raises the discount ceiling from {{personal}}% to {{franquicia}}%, and what makes the commissions you generate accrue to you.",
  "Cómo funciona la franquicia digital": "How the digital franchise works",

  // ── Los dos llamados del final ────────────────────────────────────
  //
  // Son los dos que pide `docs/01_MODELO_FRANQUICIA_Y_ONBOARDING.md`. El
  // primero apunta al creador de paquetes, que NO existe todavía: su
  // botón va deshabilitado y la nota al pie dice por qué.
  "¿No encuentras el paquete ideal?": "Can't find the right package?",
  "Podrás armar el tuyo eligiendo productos y cantidades, con el mismo descuento y el mismo cobro mensual.":
    "You'll be able to build your own by picking products and quantities, with the same discount and the same monthly charge.",
  "¡Crea el tuyo!": "Create your own!",
  "Estamos construyendo el creador de paquetes.":
    "We're still building the package creator.",
  "Mientras tanto puedes armar tu pedido en":
    "In the meantime you can put your order together in",
  "la tienda": "the shop",
  "¿Buscas producto al por mayor o quieres iniciar tu propio negocio digital?":
    "Looking for wholesale product, or want to start your own digital business?",
  "La franquicia digital te da tu tienda, el acceso a los paquetes mayoristas y las comisiones de tu red.":
    "The digital franchise gives you your own store, access to wholesale packages and the commissions from your network.",
  "Adquiere una franquicia digital": "Get a digital franchise",
};
